module.exports = __webpack_public_path__ + "static/media/mt-ut-img-11.4c593d5d.png";